<template>
    <div id="app" class="d-flex flex-column vh-100" :style="styleObject">
        <Navbar></Navbar>
        <div class="container pb-3">
            <div class="row h-100">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <router-view/>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Navbar from "./components/Navbar";
    import Footer from "./components/Footer";
    import getEnv from './utils/env'
    
    export default {
        name: "app",
        metaInfo: {
            title: getEnv('VUE_APP_TITLE_PAGE'),
            link: [
                { rel: 'icon', href: getEnv('VUE_APP_FAVICON') }
            ]
        },
        components: {Navbar, Footer},
        data() {
            return {
                link:{
                    color: getEnv('VUE_APP_NAVBAR_LINKS_COLOR'),
                },
                navbar:{
                    color: getEnv('VUE_APP_NAVBAR_COLOR'),
                },
                button: {
                    color: getEnv('VUE_APP_BUTTONS_COLOR'),
                    colorHover: getEnv('VUE_APP_BUTTONS_HOVER_COLOR'),
                }
            };
        },
        computed: {
            styleObject: function() {
                return {
                    '--color-link': this.link.color,
                    '--color-btn': this.button.color,
                    '--color-btn-hover': this.button.colorHover,
                    '--color-navbar': this.navbar.color
                }
            }
        },
        mounted() {
            this.$store.dispatch('init/setInitHttp',this);
        }
    }
</script>
<style>
    .vh-70 {
        height: 70vh !important;
    }
    .bg-custom {
        background-color: var(--color-navbar) !important;
    }

    .navbar-nav .nav-link.active {
        color: var(--color-link)  !important;
    }

    .navbar-dark .navbar-nav .nav-link:hover,
    .navbar-dark .navbar-nav .nav-link:focus {
        color: var(--color-link) !important;
    }

    .btn-custom {
        color: #fff !important;
        background-color: var(--color-btn) !important;
        border-color: var(--color-btn) !important;
    }

    .btn-custom:not(.disabled):hover {
        color: #fff !important;
        background-color: var(--color-btn-hover) !important;
        border-color: var(--color-btn-hover)!important;
    }

</style>